import { createAction } from "@reduxjs/toolkit";
import type { UpdateAdminStudioBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateAdminStudio = createApiThunk<void, UpdateAdminStudioBody>(
  "admin/studio/update",
  async (body, { extra: { adminRepository } }) => {
    await adminRepository!.updateStudio(body);
  },
);

export const resetUpdateAdminStudio = createAction("admin/studio/resetUpdate");
